import React from "react";
import { Box, Typography, MenuItem, FormControl, Select } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const EngagementFilter = ({ isManager, teamUsers, filter, handleChange }) => {
  const theme = useTheme();
  return isManager ? (
    <Box>
      <Typography
        sx={{
          fontSize: theme.typography.textXS.fontSize,
          lineHeight: theme.typography.textXS.lineHeight,
          fontWeight: theme.typography.fontWeightLight,
          fontStyle: "italic",
          mb: theme.customSpacing.sm,
        }}
      >
        Filter:
      </Typography>

      <FormControl>
        <Select
          value={filter}
          onChange={handleChange}
          displayEmpty
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: theme.palette.background.primary,
                color: theme.palette.text.primary,
                border: `1.5px solid ${theme.palette.border.brand}`,
                borderRadius: 2,
                borderTop: "none",
              },
            },
          }}
          sx={{
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            borderRadius: 2,
            padding: 0,
            backgroundColor: "transparent",
            border: `1.5px solid ${theme.palette.border.brand}`,
            "& .MuiSelect-select": {
              paddingY: theme.customSpacing.sm,
              paddingX: theme.customSpacing.xl,
              fontSize: "12px",
            },
            "& .MuiSelect-icon": {
              color: "#fff",
            },
            "& fieldset": {
              border: "none",
            },
          }}
        >
          <MenuItem sx={{ fontSize: "12px" }} value="all-members">
            All Members
          </MenuItem>
          {teamUsers.map((user) => (
            <MenuItem
              key={user.id}
              value={user.id}
              sx={{
                fontSize: "12px",
              }}
            >
              {user.first_name} {user.last_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  ) : null;
};

export default EngagementFilter;
